import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';

@Component({
    selector: 'app-plain-text',
    templateUrl: './plain-text.page.html',
    styleUrls: ['./plain-text.page.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PlainTextPage {
  @Input() data: string;
  @Input() title: string;
  textStr: string;

  constructor(
    private modalCtrl: ModalController
  ) { }

  // ngOnInit() {
  // }
  ionViewWillEnter() {
    this.textStr = this.data;
    console.log('opened ');
  }


  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }

}
